import assoc from "ramda/es/assoc"
import compose from "ramda/es/compose"
import map from "ramda/es/map"
import prop from "ramda/es/prop"
import reduce from "ramda/es/reduce"
import {
  INITIAL,
  PENDING,
  COMPLETED,
  FAILED,
} from "src/engine/modules/constants"
import {
  LOAD_PERMISSIONS_STARTED,
  LOAD_PERMISSIONS_COMPLETED,
  LOAD_PERMISSIONS_FAILED,
  LOAD_USER_STARTED,
  LOAD_USER_COMPLETED,
  LOAD_USER_FAILED,
} from "../actions/types"

const INITIAL_STATE = {
  roles: {},
  user: null,
  userStatus: INITIAL,
  permissions: {},
  permissionsStatus: INITIAL,
}

const transformPermissionsToObject = compose(
  reduce(
    (permissions, permission) => ({ ...permissions, [permission]: true }),
    {},
  ),
  map(prop(`key`)),
)

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOAD_PERMISSIONS_STARTED: {
      return assoc(`permissionsStatus`, PENDING)(state)
    }
    case LOAD_PERMISSIONS_COMPLETED: {
      return compose(
        assoc(`permissionsStatus`, COMPLETED),
        assoc(
          `permissions`,
          transformPermissionsToObject(action.payload.permissions),
        ),
      )(state)
    }
    case LOAD_PERMISSIONS_FAILED: {
      return assoc(`permissionsStatus`, FAILED)(state)
    }
    case LOAD_USER_STARTED: {
      return assoc(`userStatus`, PENDING)(state)
    }
    case LOAD_USER_COMPLETED: {
      const transformRolesToObject = compose(
        reduce((roles, role) => ({ ...roles, [role]: true }), {}),
        map(prop(`name`)),
      )
      return compose(
        assoc(`userStatus`, COMPLETED),
        assoc(`user`, action.payload.user),
        assoc(`roles`, transformRolesToObject(action.payload.roles)),
      )(state)
    }
    case LOAD_USER_FAILED: {
      return assoc(`userStatus`, FAILED)(state)
    }
    default:
      return state
  }
}
